import { lastIndexOf } from "lodash";
import React, { FC, memo, useMemo } from "../../../lib/teact/teact";
import { IKetQua } from "./types";
import { KetQuaUtils } from "./ketquaUtils";

type OwnProps = {
    kqByDai: IKetQua;
}

const ViewKetQuaByDai: FC<OwnProps> = ({ kqByDai }) => {
    function sortByGiai() {
        if (!kqByDai || !kqByDai.Giais) {
            return []
        }
        const tmp = kqByDai.Giais.sort((a, b) => {
            if (a.Key > b.Key) return -1
            return 1
        })
        return tmp
    }
    if (kqByDai)
        kqByDai.Giais = sortByGiai()
    const kqDisplay = useMemo(() => {
        return KetQuaUtils.BuildDisplayKetQua(kqByDai)
    }, [kqByDai])
    function renderGiai(so: string[]){
        return so.map((s, index) => {
            return <span key={index}>{s}</span>
        })
    }
    return (
        <div>
            <table style='width:100%; padding:2px;'>
                <tr>
                    <td>Giải.8</td>
                    <td  className="kqxs-table-cell">{renderGiai(kqDisplay.G8)}</td>
                </tr>
                <tr>
                    <td>Giải.7</td>
                    <td className="kqxs-table-cell">{renderGiai(kqDisplay.G7)}</td>
                </tr>
                <tr>
                    <td>Giải.6</td>
                    <td className="kqxs-table-cell">{renderGiai(kqDisplay.G6)}</td>
                </tr>
                <tr>
                    <td>Giải.5</td>
                    <td className="kqxs-table-cell">{renderGiai(kqDisplay.G5)}</td>
                </tr>
                <tr>
                    <td>Giải.4</td>
                    <td className="kqxs-table-cell">{renderGiai(kqDisplay.G4)}</td>
                </tr>
                <tr>
                    <td>Giải.3</td>
                    <td className="kqxs-table-cell">{renderGiai(kqDisplay.G3)}</td>
                </tr>
                <tr>
                    <td>Giải.2</td>
                    <td className="kqxs-table-cell">{renderGiai(kqDisplay.G2)}</td>
                </tr>
                <tr>
                    <td>Giải.1</td>
                    <td className="kqxs-table-cell">{renderGiai(kqDisplay.G1)}</td>
                </tr>
                <tr>
                    <td>ĐB</td>
                    <td className="kqxs-table-cell">{renderGiai(kqDisplay.G0)}</td>
                </tr>
            </table>
        </div>
    )
}
export default memo(ViewKetQuaByDai)